<template>
  <div class="table-wrapper shadow-muted-super mt-2" ref="headerSummarySection">
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
      <b-table
        @row-selected="onRowSelected"
        selectable
        :fields="visibleFields"
        :items="items"
        ref="theTable"
        class="bg-white shadow-muted-super sum-header mb-0"
        head-variant="light"
        no-border-collapse
        small
        :sticky-header="tableHeight"
        :filter="AppState.cnrSearchText"
        show-empty
        @row-clicked="
          item => {
            $router.push('/risks/allocationunits/' + $route.params.id + '/' + item.DbId);
          }
        "
        tbody-tr-class="action-button"
        @filtered="filteredItems => recalcSumHeaders(filteredItems)"
      >
        <template #head(checked)>
          <b-form-checkbox
            class="ml-2"
            :disabled="items.length == 0"
            v-model="checkedAllTableEntries"
            @change="onCheckAllTableEntries"
          ></b-form-checkbox>
        </template>
        <template #head(AmountChance)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumAmountChance, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountChanceProg)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumAmountChanceProg, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountRisiko)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumAmountRisiko, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountRisikoProg)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumAmountRisikoProg, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(actions)="data">
          {{ data.label }}

          <!-- Three vertical dots for showing visible field selection modal -->
          <span @click="$bvModal.show('risksVEDetailList')" role="button">
            <b-icon icon="three-dots-vertical" class="float-right no-outline" style="margin-top: 4px" />
          </span>
          <!--
          <b-modal
            cancel-disabled
            ok-disabled
            hide-footer
            hide-backdrop
            hide-header
            no-fade
            id="ccc"
            body-class="p-0"
            content-class="border-0"
          >
            <b-list-group>
              <b-list-group-item v-for="item in fields.filter(x => x.hideable == true)" :key="item.key" class="p-2">
                <b-form-checkbox
                  @change="onClickColumnVisible(item)"
                  v-model="item.visible"
                  value="true"
                  unchecked-value="false"
                >
                  {{ item.label }}
                </b-form-checkbox>
              </b-list-group-item>
            </b-list-group>
          </b-modal> -->
        </template>
        <template #cell(checked)="data">
          <b-form-checkbox
            class="ml-2"
            @change="checked(data)"
            v-model="data.rowSelected"
            :disabled="data.item.editMode"
          ></b-form-checkbox>
        </template>
        <template #cell(actions)="data">
          <b-icon
            class="action-button text-grey"
            style="width: 18px; height: 18px"
            icon="arrow-right"
            title="Chancen & Risiken"
            @click.stop="$router.push('/risks/allocationunits/' + $route.params.id + '/' + data.item.DbId)"
          />
          <b-icon
            icon="trash"
            variant="grey"
            class="action-button ml-2"
            style="width: 16px; height: 16px"
            title="Beleg löschen"
            @click.stop="deleteRecord(data.item)"
            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
          />
        </template>
      </b-table>
    </b-overlay>
    <TableColumnSelector
      :fields="fields"
      id="risksVEDetailList"
      @ok="AppState.updateVisibleFields('risksVEDetailList', fields)"
    ></TableColumnSelector>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import SettingsStore from '@/store/Settings';
import RisksService from '@/service/RisksService';
import TableColumnSelector from '@/components/TableColumnSelector';

export default {
  async activated() {
    AppState.loadVisibleFields('risksVEDetailList', this.fields);
    AppState.cnrSearchText = AppState.cnrSearchTextVeList;

    AppState.isLoading = false;

    //AppState.currentCnRVE = await AllocationUnitsService.getAllocationUnitById(this.$route.params.id);
    AppState.currentCnRVE = await RisksService.getVESummary(this.$route.params.id);

    this.items = await this.loadCnRs();

    this.$eventBus.$on('CnR:header:toggle', this.onWindowResize);
    this.$eventBus.$on('CnR:filter', this.handleFilter);

    //this.$eventBus.$emit('CnR:rowsSelected', this.selectedRows);
    /*
    if (this.selectedRows.length > 0 && this.filterEnabled) {
      this.items = this.selectedRows;
      this.$refs.theTable.selectAllRows();
    }*/
    this.$refs.theTable.clearSelected();
    this.recalcSumHeaders(this.items);
    //window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls
    //this.onWindowResize();

    this.$nextTick(() => (this.isLoading = false));
  },
  async deactivated() {
    AppState.cnrSearchTextVeList = AppState.cnrSearchText;
  },
  components: {
    TableColumnSelector
  },
  data() {
    return {
      SettingsStore,
      items: [{ DbId: 30 }],
      isLoading: true,
      searchText: '',
      tableHeight: '500px',
      checkedAllTableEntries: false,
      selectedRows: [],
      filterEnabled: false,
      AppState,
      SumAmountChance: 0.0,
      SumAmountChanceProg: 0.0,
      SumAmountRisiko: 0.0,
      SumAmountRisikoProg: 0.0,
      fields: [
        {
          hideable: false,
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index: 10;'
        },
        {
          hideable: false,
          visible: true,
          key: 'Datum',
          label: 'Datum',
          thClass: 'align-top',
          sortable: true,
          thStyle: 'z-index: 10;',
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },
        {
          hideable: false,
          visible: true,
          key: 'Description',
          label: 'Bezeichnung',
          thClass: 'align-top',
          sortable: true,
          thStyle: 'z-index: 10;'
        },
        {
          visible: true,
          hideable: true,
          key: 'AmountChance',
          label: 'Chancen',
          thClass: 'align-top text-right',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thStyle: 'z-index: 10;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          visible: true,
          hideable: true,
          key: 'AmountChanceProg',
          label: '(C-prognoserelevant)',
          thClass: 'align-top text-right text-nowrap',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thStyle: 'z-index: 10;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          visible: true,
          hideable: true,
          key: 'AmountRisiko',
          label: 'Risiken',
          thClass: 'align-top text-right',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thStyle: 'z-index: 10;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          visible: true,
          hideable: true,
          key: 'AmountRisikoProg',
          label: '(R-prognoserelevant)',
          thClass: 'align-top text-right text-nowrap',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thStyle: 'z-index: 10;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: false,
          visible: true,
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'sticky-col last-col text-center align-middle',
          thClass: 'sticky-col last-col align-top noselect',
          thStyle: 'z-index: 10'
        }
      ]
    };
  },
  methods: {
    async loadCnRs() {
      return RisksService.getCnRsByVeId(this.$route.params.id);
    },

    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm('Soll der Eintrag "' + item.Description + '" wirklich gelöscht werden?', {
          title: 'Chance/Risiko löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            RisksService.delete(item)
              .then(() => {
                this.$showSuccess(this, 'Chance/Risiko löschen', 'Chance/Risiko erfolgreich gelöscht');
                this.recalcSumHeaders(this.items);
                this.$eventBus.$emit('CnR:deleted');
              })
              .catch(this.$handleError);
            this.$utils.deleteItemFromArray(this.items, x => x.DbId == item.DbId);
          }
        });
    },
    recalcSumHeaders(items) {
      this.SumAmountChance = 0.0;
      this.SumAmountChanceProg = 0.0;
      this.SumAmountRisiko = 0.0;
      this.SumAmountRisikoProg = 0.0;
      items.map(item => {
        this.SumAmountChance += item.AmountChance;
        this.SumAmountChanceProg += item.AmountChanceProg;
        this.SumAmountRisiko += item.AmountRisiko;
        this.SumAmountRisikoProg += item.AmountRisikoProg;
      });
      /*
      this.fields.forEach(x => {
        if (x.sumHeader && x.sumHeader == true) {
          x.sum = 0;
        }
      });

      this.items.forEach(x => {
        this.fields.forEach(field => {
          if (field.sumHeader) {
            field.sum += isNaN(parseFloat(x[field.key])) ? 0 : parseFloat(x[field.key]);
          }
        });
      });
      this.$forceUpdate();
      */
    },
    onCheckAllTableEntries() {
      if (this.checkedAllTableEntries) {
        this.$refs.theTable.selectAllRows();
      } else {
        this.$refs.theTable.clearSelected();
      }
    },
    checked(data) {
      if (data.rowSelected) {
        this.$refs.theTable.selectRow(data.index);
      } else {
        this.$refs.theTable.unselectRow(data.index);
      }
    },
    onRowSelected(selectedItems) {
      this.selectedRows = selectedItems;
      this.$eventBus.$emit('CnR:rowsSelected', this.selectedRows);
      if (selectedItems.length < this.items.length) {
        this.checkedAllTableEntries = false;
      } else {
        this.checkedAllTableEntries = true;
      }
    },
    handleFilter(filterEnabled) {
      this.filterEnabled = filterEnabled;
      if (filterEnabled) {
        this.itemsBackup = [...this.items];
        this.items = this.selectedRows;
        this.$nextTick(() => {
          this.$refs.theTable.selectAllRows();
        });
      } else {
        this.items = this.itemsBackup;
      }
      this.recalcSumHeaders(this.items);
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible == true || field.visible == 'true');
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'VE Budget') {
      AppState.cnRVEListTableScrollPosition = this.$refs.theTable.$el.scrollTop;
    } else {
      AppState.cnRVEListTableScrollPosition = 0;
    }

    next();
  }
};
</script>

<style>
.first-col {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  left: 0;
}
.second-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  left: 50px;
}

.third-col {
  width: 220px;
  min-width: 220px;
  max-width: 220px;
  left: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.last-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  right: 0;
}
.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}
.table-striped tbody tr:nth-of-type(odd) td.sticky-col {
  background-color: #efefef !important;
}
.table-striped tbody tr:nth-of-type(even) td.sticky-col {
  background-color: #f5f5f5 !important;
}
.table-wrapper td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.table-wrapper td:last-child {
  border-left: 1px solid #ced2d6;
}
.table-wrapper td:nth-last-child(2) {
  border-left: none;
  border-right: none;
}
.table.b-table > tbody > .table-active,
.table.b-table > tbody > .table-active > th,
.table.b-table > tbody > .table-active > td {
  background-color: #f5f5f5;
}
#ccc > .modal-dialog {
  position: absolute;
  top: 365px;
  right: 13px;
}
</style>
